import { SourcePreview } from "#features/conversations/components/conversation-source/source-preview/SourcePreview.tsx";
import type { SourcePreviewProps } from "#features/conversations/components/conversation-source/source-preview/SourcePreviewProps.ts";
import { useConversationSource } from "#features/conversations/hooks/useConversationSource.ts";

export const DefaultPreview = ({ source }: SourcePreviewProps) => {
    const { title, author, date, description } = useConversationSource(source);

    return (
        <SourcePreview
            source={source}
            title={title}
            author={author}
            date={date}
            description={description}
        />
    );
};
